import {
  createSlice,
  createAsyncThunk,
  createDraftSafeSelector,
} from '@reduxjs/toolkit';

import { api } from '../../api/api';
import { logout } from '../Login/loginSlice';

export const loadEngines = createAsyncThunk('engines/loadEngines', async () => {
  const response = await api.engines();
  return response;
});

// Global admin only: hide (disabled: true) or show an engine in the create-task picker.
export const setEngineDisabled = createAsyncThunk(
  'engines/setEngineDisabled',
  async ({ uuid, disabled }) => {
    const response = await api.setEngineDisabled(uuid, disabled);
    return response;
  },
);

// selectors
const selectSelf = (state) => state.engines;
// All engines with models (archived and hidden included), sorted by alias.
export const selectEngines = createDraftSafeSelector(
  selectSelf,
  (engines) => engines.engines,
);
// Engines shown on the Apps page: everything except archived.
export const selectListedEngines = createDraftSafeSelector(
  selectEngines,
  (engines) => engines.filter((engine) => !engine.archived),
);
// Engines a task can be created from: not archived and not hidden by an admin.
export const selectCreatableEngines = createDraftSafeSelector(
  selectEngines,
  (engines) =>
    engines.filter((engine) => !engine.archived && !engine.disabled),
);
export const selectEnginesLoading = createDraftSafeSelector(
  selectSelf,
  (engines) => engines.loading,
);
export const selectEnginesFailedToLoad = createDraftSafeSelector(
  selectSelf,
  (engines) => engines.failedToLoad,
);

const engineSlice = createSlice({
  name: 'engines',
  initialState: {
    failedToLoad: false,
    loading: false,
    engines: [],
    allEngines: undefined,
  },
  reducers: {},
  extraReducers: {
    [loadEngines.pending]: (state) => {
      state.loading = true;
      state.failedToLoad = false;
    },
    [loadEngines.fulfilled]: (state, action) => {
      state.loading = false;
      state.engines = action.payload
        .filter((engine) => engine.models && engine.models.length > 0)
        .sort(sortAlphaNum);
      state.allEngines = action.payload;
    },
    [loadEngines.rejected]: (state, action) => {
      state.loading = false;
      state.failedToLoad = true;
      state.engines = [];
    },
    [setEngineDisabled.fulfilled]: (state, action) => {
      const { uuid } = action.meta.arg;
      // Trust the server's echoed value; fall back to what we asked for.
      const disabled =
        typeof action.payload?.disabled === 'boolean'
          ? action.payload.disabled
          : action.meta.arg.disabled;
      const patch = (list) => {
        (list || []).forEach((engine) => {
          if (engine.uuid === uuid) {
            engine.disabled = disabled;
          }
        });
      };
      patch(state.engines);
      patch(state.allEngines);
    },
    [logout]: (state) => {
      state.failedToLoad = false;
      state.engines = [];
      state.allEngines = undefined;
    },
  },
});

export const {} = engineSlice.actions;

export default engineSlice.reducer;

// alphanum sorter
function sortAlphaNum(c, d) {
  let a = ((c.models && c.models[0] && c.models[0].alias) || '').toLowerCase();
  let b = ((d.models && d.models[0] && d.models[0].alias) || '').toLowerCase();
  return a.localeCompare(b, 'en');
}
